import { useGoogleMap } from "@react-google-maps/api";
import { useRef, useEffect } from "react";

interface MapControlProps {
  position: keyof typeof google.maps.ControlPosition;
}

export const MapControl = (props: React.PropsWithChildren<MapControlProps>) => {
  const map = useGoogleMap();
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (map && ref.current) {
      map.controls[window.google.maps.ControlPosition[props.position]].push(
        ref.current
      );
    }
  }, [map, ref]);
  return <div ref={ref}>{props.children}</div>;
};
